interface QueryParams {
    [key: string]: string | number;
}

export default {
    getQueryVariable(variable: string): string | false {
        const query = window.location.search.substring(1);
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");
            if (pair[0] === variable) {
                return pair[1];
            }
        }
        return false;
    },

    getPath(): string | undefined {
        const urlPath = window.location.pathname.split('?');
        if (urlPath) {
            return urlPath[0];
        }
    },

    getStartPath(): string {
        //return the begining of the path so privacy-policy/version to return /privacy-policy
        const urlPath = window.location.pathname;
        const lastSlash = urlPath.lastIndexOf("/");
        if (lastSlash === 0) return urlPath;
        else return urlPath.substr(0, urlPath.lastIndexOf("/"));
    },

    getSearch(): string | undefined {
        if (window.location.search) {
            return window.location.search.substring(1);
        }
    },

    createPersistentSearchString(supplierId?: string): string {
        const initLat = this.getQueryVariable('initLat');
        const initLng = this.getQueryVariable('initLng');

        let searchParams: QueryParams = {};

        if (initLat && initLng && !supplierId) {
            searchParams = {initLat: initLat, initLng: initLng};
        } else if (initLat && initLng && supplierId) {
            searchParams = {initLat: initLat, initLng: initLng, selectedSupplierId: supplierId};
        }

        return this.createQueryString(searchParams);
    },

    createQueryString(params: QueryParams): string {
        let queryString = '';
        let isFirstParam = true;
        for (const key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                const value = params[key];
                if (isFirstParam) {
                    queryString = '?' + queryString + key + '=' + value;
                    isFirstParam = false;
                } else {
                    queryString = queryString + '&' + key + '=' + value;
                }
            }
        }
        return queryString;
    },

    createSignUpTypeQueryParam(signUpType: string): string {
        return '?type=' + signUpType;
    },

    formatEncodePath(path: string): string {
        const formattedPath = path.toLowerCase().replaceAll(/\s/g, '-');
        return encodeURIComponent(formattedPath);
    }
}
